import { makeAutoObservable } from 'mobx'

class ChangeOperatorStatusStore {
  isOpen: boolean = false
  requestId: number | null = null
  updateOrderCallback: ((order: any) => void) | null = null

  constructor() {
    makeAutoObservable(this)
  }

  setIsOpen = (value: boolean) => {
    this.isOpen = value
  }

  setRequestId = (requestId: number | null) => {
    this.requestId = requestId
  }

  setUpdateOrderCallback = (callback: ((order: any) => void) | null) => {
    this.updateOrderCallback = callback
  }
}

export const changeOperatorStatusStore = new ChangeOperatorStatusStore()
